import { useState, useEffect } from "react";

export default function InclusionList({product, ...props}) {
  
  useEffect(()=>{
    window.scrollTo(0, 0);
  },[]);
  return (
    <>
      <div className="text-left">
        <div className="mb-5">
          <h3 className="text-lg font-bold leading-tight">Inclusions</h3>
        </div>

        <p className="text-sm leading-tight pb-8">
          More reasons to drive with peace of mind with the following
          additional coverages:
        </p>

        <div>
          <ol className="list-decimal text-xs text-gray-500 px-3">
            <li className="pb-3">
              <strong>FREE Auto Personal Accident Insurance</strong>
              <p className="py-2">
                You get free coverage while riding your insured vehicle:
              </p>
              <ul className="list-disc pl-5">
                <li>₱100,000 if you die or become disabled due to an accident</li>
                <li>₱20,000 for medical expenses</li>
                <li>₱10,000 for surgery</li>
                <li>₱10,000 for burial</li>
              </ul>
            </li>
            <li className="pb-3">
              <strong>FREE Auto Personal Accident Insurance</strong>
              <p className="py-2">
                You're protected 24/7 anywhere in the world (except while riding
                your insured motorcycle) with ₱100,000 coverage for accidental
                death.
              </p>
            </li>
            <li className="pb-3">
              <strong>Loss of Use</strong>
              <p className="py-2">
                This benefit applies once your vehicle is confirmed unusable and
                after Standard Insurance has reviewed and determined liability.
                </p>
                <p className="py-2">
                You can claim up to ₱1,500 per year, with a daily allowance of ₱300
                for up to 5 days, upon submission of original receipts. The allowance
                starts three days after repairs begin or on the date your vehicle is
                declared a total loss due to an accident, and ends when the settlement
                check is released or the ₱1,500 limit is reached — whichever comes
                first.
              </p>
              <p className="py-2">
                This benefit does not cover theft, carnapping, or catastrophic losses.
              </p>
            </li>
            <li className="pb-3">
              <strong>Use of Standard Insurance Technical and Training Center (TTC)</strong>
              <p className="py-2">
                At Standard Insurance's Technical and Training Center (TTC) in
                Naic, Cavite, you'll enjoy advanced repair services — with free
                pickup and delivery in Metro Manila and nearby provinces, waived
                deductibles and depreciation on valid claims, and a loaner car to
                keep you on the move.
              </p>
            </li>
            <li className="pb-3">
              <strong>Auto Road Assistance</strong>
              <p className="py-2">
                24/7 roadside help for vehicles up to 15 years old.
              </p>
            </li>
            <li className="pb-3">
              <strong>Add-on Accessories</strong>
              <p className="py-2">
                Standard accessories? Automatically covered. Added extras? Simply
                declare them for complete protection.
              </p>
            </li>
            <li className="pb-3">
              <strong>No Claim Bonus</strong>
              <p className="py-2">
                As a reward for safe driving, you'll receive a ₱500 discount on your
                renewal if you've had no claims on your first year policy.
              </p>
            </li>
            <li className="pb-3">
              <strong>Importation Clause</strong>
              <p className="py-2">
                If parts need to be imported, we cover the actual cost of the parts or
                vehicle (excluding taxes, freight, and other charges).
              </p>
            </li>
            <li className="pb-3">
              <strong>Immediate Glass and Mirror Repair</strong>
              <p className="py-2">
                You can replace damaged glass or side mirrors right away (subject
                to reimbursement).
              </p>
            </li>

            <li className="pb-3">
              <strong>Airbag Coverage</strong>
              <p className="py-2">
                If your airbag deploys due to an accident, we'll cover the cost of
                replacement and reinstallation.
              </p>
            </li>


          </ol>
        </div>
        {/* <Accordion questionsAnswers={questionsAnswers}/> */}
      </div>
    </>
  );
}
